import { FactorsVaccinationsModel } from '../../model/factors-vaccinations.model';
import { mapVaccinations } from './../../utils/map-vaccinations';
import { TFunction } from 'i18next';

const factorsVaccinationsData = (t: TFunction): FactorsVaccinationsModel => {
  return {
    birthDate_less_than_18: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations([], t),
      highlyRecommendedVaccinations: mapVaccinations([], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    birthDate_18_to_49: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['HPV'], t),
      highlyRecommendedVaccinations: mapVaccinations([], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    birthDate_50_to_54: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['SP', 'HZV_1'], t),
      highlyRecommendedVaccinations: mapVaccinations([], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    birthDate_55_to_59: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['SP', 'HZV_1', 'RSV_1'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    birthDate_60_to_64: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['SP', 'HZV_1'], t),
      highlyRecommendedVaccinations: mapVaccinations(['RSV', 'C', 'GR_HD', 'WB_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    birthDate_over_65: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['HZV_1'], t),
      highlyRecommendedVaccinations: mapVaccinations(['RSV', 'C', 'SP', 'GR_HD', 'WB_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    pregnancy: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations([], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR', 'RSV_2', 'DTP_1'], t),
      contraindicatedVaccinations: mapVaccinations(['MMR_1', 'OW_1', 'HPV', 'HZV_1'], t)
    },
    plannedPregnancy: {
      mandatoryVaccinations: mapVaccinations(['WB_1'], t),
      recommendedVaccinations: mapVaccinations([], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR', 'OW_1', 'MMR_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    circulatorySystemDisease: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['SP'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR', 'HZV_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    diabetes: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['SP'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR', 'HZV_1', 'WB_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    chronicRespiratoryDisease: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['SP'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR', 'HZV_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    chronicKidneyDisease: {
      mandatoryVaccinations: mapVaccinations(['WB_2'], t),
      recommendedVaccinations: mapVaccinations(['SP', 'NM'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR', 'HZV_1', 'WB_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    chronicLiverDisease: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['SP', 'NM'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR', 'HZV_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    viralHepatitisC: {
      mandatoryVaccinations: mapVaccinations(['WB_1'], t),
      recommendedVaccinations: mapVaccinations(['SP', 'NM'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR', 'HZV_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    depression: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations([], t),
      highlyRecommendedVaccinations: mapVaccinations(['HZV_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    neoplasticDisease: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['SP_1', 'NM'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR', 'WB_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    spleenDysfunction: {
      mandatoryVaccinations: mapVaccinations(['DTP', 'HiB', 'SP', 'MMR_1', 'PO_1', 'WB'], t),
      recommendedVaccinations: mapVaccinations(['SP', 'NM'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR', 'HZV_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    immuneDisorders: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['SP', 'HiB_1'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR', 'HZV_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    immunosuppressiveDrugs: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['SP', 'HiB_1'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR', 'HZV_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    hivInfection: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['SP', 'NM'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    boneMarrowTransplantationBefore: {
      mandatoryVaccinations: mapVaccinations(['DTP', 'HiB', 'SP', 'MMR_1', 'PO_1', 'WB'], t),
      recommendedVaccinations: mapVaccinations(['NM'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    boneMarrowTransplantationAfter: {
      mandatoryVaccinations: mapVaccinations(['DTP', 'HiB', 'SP', 'MMR_1', 'PO_1', 'WB'], t),
      recommendedVaccinations: mapVaccinations(['NM'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    organTransplantationBefore: {
      mandatoryVaccinations: mapVaccinations(['DTP', 'HiB', 'SP', 'MMR_1', 'PO_1', 'WB'], t),
      recommendedVaccinations: mapVaccinations(['NM_1'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    organTransplantationAfter: {
      mandatoryVaccinations: mapVaccinations(['DTP', 'HiB', 'SP', 'MMR_1', 'PO_1', 'WB'], t),
      recommendedVaccinations: mapVaccinations(['NM_1'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    cochlearImplantation: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['SP'], t),
      highlyRecommendedVaccinations: mapVaccinations([], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    cerebroSpinalFluidLeak: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['SP'], t),
      highlyRecommendedVaccinations: mapVaccinations([], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    autoimmuneDisease: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations([], t),
      highlyRecommendedVaccinations: mapVaccinations([], t),
      contraindicatedVaccinations: mapVaccinations(['HZV_1'], t)
    },
    medicalStudentHealthcare: {
      mandatoryVaccinations: mapVaccinations(['WB_1'], t),
      recommendedVaccinations: mapVaccinations(['NM'], t),
      highlyRecommendedVaccinations: mapVaccinations(['DTP', 'GR', 'MMR_1', 'OW_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    neonatologyPediatricsWorker: {
      mandatoryVaccinations: mapVaccinations(['WB_1'], t),
      recommendedVaccinations: mapVaccinations(['NM'], t),
      highlyRecommendedVaccinations: mapVaccinations(['WA', 'DTP', 'GR', 'MMR_1', 'OW_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    infectiousDiseasesGastroenterologyWorker: {
      mandatoryVaccinations: mapVaccinations(['WB_1'], t),
      recommendedVaccinations: mapVaccinations(['NM'], t),
      highlyRecommendedVaccinations: mapVaccinations(['WA', 'DTP', 'GR', 'MMR_1', 'OW_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    workingWithSevereImmunodeficiency: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations([], t),
      highlyRecommendedVaccinations: mapVaccinations([], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    policeman: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations([], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR', 'WB_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    fireFighter: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['KZM'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR', 'WB_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    borderGuard: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['KZM'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR', 'WB_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    army: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['KZM'], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR', 'WB_1'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    healthCareHomeResident: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations([], t),
      highlyRecommendedVaccinations: mapVaccinations(['GR'], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    otherMultiPersonPlace: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['MMR_1', 'NM'], t),
      highlyRecommendedVaccinations: mapVaccinations([], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    outdoorActivity: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['KZM'], t),
      highlyRecommendedVaccinations: mapVaccinations([], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    hepatitisBExposure: {
      mandatoryVaccinations: mapVaccinations(['WB_1'], t),
      recommendedVaccinations: mapVaccinations([], t),
      highlyRecommendedVaccinations: mapVaccinations([], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    },
    cigarettesAlcoholAbuse: {
      mandatoryVaccinations: mapVaccinations([], t),
      recommendedVaccinations: mapVaccinations(['SP'], t),
      highlyRecommendedVaccinations: mapVaccinations([], t),
      contraindicatedVaccinations: mapVaccinations([], t)
    }
  };
};

export default factorsVaccinationsData;
